import state from "./state";

export default {
    getSidebarShow(state){
        return state.showSidebar;
    },
    getSidebarMinimize(state){
        return state.sidebarMinimize;
    },
    getroles(state) {
        return state.roles;
    },
    getCountries(state){
        return state.countries;
    },
    getFactories(state){
        return state.factories;
    },
    getCurrencies(state){
        return state.currencies;
    },
    getSku(state){
        return state.sku;
    },
    getSkuAgainstCurrency(state) {
      return state.currency_skus;
    },
    getFactorySku(state){
        return state.factory_skus;
    },
    getSteps(state){
        return state.steps;
    },
    getCategories(state){
        return state.categories;
    },
    getDefaultCategories(state){
        return state.default_categories;
    },
    totalPages(state){
        return state.total_pages;
    },
    getProductSteps(state){
        return state.selected_steps;
    },
    getErrors(state){
        return state.errors;
    },
    getFiles(state){
        return state.files;
    },
    getUserFiles(state){
        return state.user_files
    },
    getusers(state){
        return state.users
    },
    getModules(state){
        return state.permission_modules;
    },
    getparentlabels(state){
        return state.parent_labels;
    },
    getpermissions(state){
        return state.permissions;
    },
    getnavigations(state) {
        return state.navigation;
    },
    getAuthorizedPermissions(state){
        return state.role_permissions;
    },
    getSeries(state){
        return state.series;
    },
    getCustomers(state){
        return state.customers
    },
    getCustomersWithCurrentProductAssigned(state){
        return state.customers_with_current_product_assigned
    },
    showLoader(state){
        return state.showLoader
    },
    getTranslations(state){
        return state.translations;
    },
}